import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Inscricao from "../pages/inscricao/page";
import Gerente from "../pages/gerente/page";
import Lojista from "../pages/lojista/page";
import NossosProdutos from "../pages/nossos-produtos/page";
import PoliticaPrivacidade from "../pages/politica-privacidade/page";
import Materia from "../pages/materia/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/nossos-produtos", element: <NossosProdutos /> },
  { path: "/inscricao", element: <Inscricao /> },
  { path: "/gerente", element: <Gerente /> },
  { path: "/lojista", element: <Lojista /> },
  { path: "/materia", element: <Materia /> },
  { path: "/politica-de-privacidade", element: <PoliticaPrivacidade /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
